module.exports = __webpack_public_path__ + "static/img/29.cf353cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/29.png
// module id = PDLS
// module chunks = 0